import api from './api';
import { unwrapList, unwrapObject, type ListResult } from './api-envelope';
import type { BrandListQuery } from './queryKeys';
import type {
  BrandType,
  CreateBrandInput,
  UpdateBrandInput,
} from '@erpgold/shared';

export const brandService = {
  list: (params: BrandListQuery): Promise<ListResult<BrandType>> =>
    api.get('/brands', { params }).then(unwrapList<BrandType>),

  getById: (id: string): Promise<BrandType> =>
    api.get(`/brands/${id}`).then(unwrapObject<BrandType>),

  create: (body: CreateBrandInput): Promise<BrandType> =>
    api.post('/brands', body).then(unwrapObject<BrandType>),

  update: (id: string, body: UpdateBrandInput): Promise<BrandType> =>
    api.put(`/brands/${id}`, body).then(unwrapObject<BrandType>),

  remove: (id: string): Promise<void> =>
    api.delete(`/brands/${id}`).then(() => undefined),
};
